import { SessionState } from '@store/entities';
import { createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import { SessionActions } from '@store/actions';

import { Session } from '@core/models';

export const sessionAdapter: EntityAdapter<Session> =
  createEntityAdapter<Session>({
    selectId: session => session.workerId,
  });

export const initialState: SessionState = sessionAdapter.getInitialState({
  selectedWorkerId: null,
  isLoading: false,
  error: null,
  tokenValidator: null,
});

export const sessionReducer = createReducer<SessionState>(
  initialState,
  on(SessionActions.loadSession, (state, { idWorker, token }) => ({
    ...state,
    selectedWorkerId: idWorker,
    tokenValidator: token,
    isLoading: true,
  })),
  on(SessionActions.loadSessionSuccess, (state, { session }) => {
    return sessionAdapter.addOne(session, { ...state, isLoading: false });
  }),
  on(SessionActions.loadSessionFailure, (state, action) => ({
    ...state,
    isLoading: false,
    error: action.error,
  })),
  on(SessionActions.clearSession, () => initialState)
);
